import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

///IDIOMAS
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector     : 'contact-form-dialog',
    templateUrl  : './form.component.html',
    styleUrls    : ['./form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class FormDialogComponent{

    constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,

    @Inject(MAT_DIALOG_DATA) public data: any) {

      lang_shedule.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });

    }



    onNoClick(): void {
	    this.dialogRef.close('close');
	  }


}
